import { render, staticRenderFns } from "./FullScreenFormEmailTemplateModal.vue?vue&type=template&id=1f39c54e&"
import script from "./FullScreenFormEmailTemplateModal.vue?vue&type=script&lang=js&"
export * from "./FullScreenFormEmailTemplateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports